<template>
  <ReassuranceItems
    v-if="productResponse && selectedOffer"
    :carrier="productResponse.carrier"
    class="mt-24"
    :merchant="selectedOffer.merchant"
    :reassurance-blocks="productResponse.reassuranceBlocks"
    :shipping="selectedOffer.shipping"
    :show-verified-refurbished="productResponse.showVerifiedRefurbished"
    :warranty-delay="selectedOffer.defaultWarrantyDelay"
  >
    <template v-if="$slots.shipping" #shipping="slotProps">
      <slot name="shipping" v-bind="slotProps" />
    </template>
    <template v-if="$slots.carrier" #carrier="slotProps">
      <slot name="carrier" v-bind="slotProps" />
    </template>
  </ReassuranceItems>
</template>

<script setup lang="ts">
import ReassuranceItems from '~/scopes/product-core/components/presentationals/ReassuranceItems/ReassuranceItems.vue'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

const { data: productResponse } = useFetchProduct()
const { selectedOffer } = useFetchPickers()
</script>
